import * as i0 from "@angular/core";
/**
 * Based Saved Item Service
 *
 * This class contains the abstract methods that all save item services must implement. Examples of saved items
 * are fund charts, metric sets, company screens, model portfolios, etc.
 */
export class BaseSavedItemService {
}
BaseSavedItemService.ɵfac = function BaseSavedItemService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BaseSavedItemService)(); };
BaseSavedItemService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: BaseSavedItemService, factory: BaseSavedItemService.ɵfac });
